///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';

import { ProductAccessoryService } from './product/product-accessory.service';
import { ProductRadioService } from './product/product-radio.service';
import { ProductService } from './product/product.service';
import { WindowRef } from './project-socket/window.service';
import { GtthCustomerLocationService } from './customer/customer-location.service';
import { GtthStaticContentService } from '../help/release-notes/service/static-content.service';
import { GtthErrorHandler } from './logger/GtthErrorHandler.service';
import { GtthSharedModule } from '../shared/shared.module';
import { GtthCustomerService } from './customer/customer.service';
import { ProjectService } from './project/project.service';

@NgModule({
    imports: [GtthSharedModule],
    declarations: [],
    providers: [
        GtthCustomerService,
        GtthCustomerLocationService,
        ProjectService,
        ProductAccessoryService,
        ProductRadioService,
        ProductService,
        WindowRef,
        GtthStaticContentService,
        {
            provide: ErrorHandler,
            useClass: GtthErrorHandler
        }
    ],
    exports: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GtthServicesModule {}
